import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, ControlValueAccessor } from '@angular/forms';
import { PGUtilities } from '../../utilities/pg-utilities';
import { PgFileType } from '../../models/file.model';

export class AttachmentData {
    name?:string;
    url?:string;
}

@Component({
    selector: 'app-pg-attachment-editor',
    templateUrl: './pg-attachment-editor.component.html',
    styleUrls: ['./pg-attachment-editor.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PgAttachmentEditorComponent),
            multi: true
        }, {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PgAttachmentEditorComponent),
            multi: true,
        }],
    standalone: false
})
export class PgAttachmentEditorComponent implements OnInit, ControlValueAccessor, Validator {
    @Input() fieldId:string;

    @Input() readonly:boolean;
    @Input() required:boolean;
    @Input() multi:boolean;

    @Input() fileType:PgFileType;
    @Input() fileOptions:any;
    @Input() groupId:string;
    @Input() realmId:string;
    @Input() directoryId:string;

    value:Array<AttachmentData> = null;

    constructor() { }

    ngOnInit() {
    }

    private _lastEmitted:string = null

    private _getToEmit() {
        let _result:any = JSON.parse(JSON.stringify(this.value));
        this._normalizeValues(_result);
        if(!this.multi) _result = _result[0] || null;

        return JSON.stringify(_result)
    }

    onValueChange() {
        if(this._onTouched) this._onTouched();
        if(this._onChange) {
            let _toEmit = this._getToEmit()

            if(this._lastEmitted != _toEmit) {
                this._lastEmitted = _toEmit
                this._onChange(_toEmit);
            }
        }
    }

    _normalizeValues(values:Array<AttachmentData>) {
        for(let j = values.length - 1; j >= 0; j--) {
            let _item = values[j]
            if(!_item.url) {
                values.splice(j, 1)
            }
            else {
                if(_item.name == null) _item.name = '';
            }
        }
    }

    addItem() {
        this.value.push({})
    }

    removeItem(item:AttachmentData) {
        let _index = this.value.indexOf(item)

        if(_index != -1) {
            this.value.splice(_index, 1)
        }

        if(this.value.length == 0) {
            this.addItem();
        }

        this.onValueChange();
    }

    // INTERFACCIA ControlValueAccessor

    writeValue(obj:string) {
        this.value = PGUtilities.tryParseJSON(obj);
        if(this.value == null) this.value = []
        else if(!(this.value instanceof Array)) this.value = [this.value]

        this._normalizeValues(this.value)

        if(this.value.length == 0) this.addItem()

        this._lastEmitted = this._getToEmit()
    }

    _onChange;

    registerOnChange(fn: any) {
        this._onChange = fn;
    }

    _onTouched;

    registerOnTouched(fn: any) {
        this._onTouched = fn;
    }

    // INTERFACCIA Validator

    validate()  {
        let _normalized:Array<AttachmentData> = JSON.parse(JSON.stringify(this.value || []));
        this._normalizeValues(_normalized);

        if(this.required && _normalized.length == 0) {
            return {
                required: {
                    valid: false
                }
            }
        }

        for(let _item of _normalized) {
            if(_item.url && !PGUtilities.urlRegExp.test(_item.url)) {
                return {
                    format: {
                        valid: false
                    }
                }
            }
        }
    };
}
